import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const refreshUserInvitation = createApiThunk<void, string>(
  "users/refreshUserInvitation",
  async (userId: string, { extra: { adminRepository } }) => {
    return adminRepository!.refreshUserInvitation(userId);
  },
);

export const resetRefreshUserInvitation = createAction("users/resetRefreshUserInvitation");
